import type { User } from '../types';

/**
 * Check if the user is an approved affiliate
 */
export const isAffiliate = (user: User | null): boolean => {
  return user?.is_affiliate === true;
};

/**
 * Check if the user is a super admin (can manage affiliates)
 */
export const isSuperAdmin = (user: User | null): boolean => {
  return user?.is_superuser === true;
};

/**
 * Check if the user can access affiliate features
 */
export const canAccessAffiliates = (user: User | null): boolean => {
  return isAffiliate(user) || isSuperAdmin(user);
};

/**
 * Get the appropriate affiliate dashboard route based on user permissions
 */
export const getAffiliateDashboardRoute = (user: User | null): string => {
  if (isSuperAdmin(user)) {
    return '/manage/affiliates';
  } else if (isAffiliate(user)) {
    return '/affiliate-dashboard';
  }
  return '/affiliate-signup';
};

/**
 * Validate a referral code format
 */
export const isValidReferralCode = (code: string): boolean => {
  return /^[A-Z0-9]{8}$/.test(code);
};

/**
 * Extract referral code from URL parameters
 */
export const extractReferralFromURL = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  const ref = urlParams.get('ref');
  return ref && isValidReferralCode(ref) ? ref : null;
};